import React from 'react';
import { gifts } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="px-6 py-12" data-id="element-10" data-mp="pjg4xyy2x3zv">
      <SectionHeading eyebrow="Se acquisti oggi ricevi anche…" data-id="element-11" data-mp="plsnoebnvidz">4 bonus gratis</SectionHeading>
      <p className="mt-2.5 text-center text-[15px] leading-[1.6] text-ink-500" data-id="element-12" data-mp="at8uo6i86ra9">
        Inclusi in ogni ordine.
      </p>

      <ul className="mt-8 grid grid-cols-2 gap-3" data-id="element-13" data-mp="1un8809mus47">
        {gifts.map(gift => <li key={gift.label} className="flex flex-col rounded-2xl border border-cream-300 bg-white p-3" data-id="element-14" data-mp="5w0do98tctal">
            <div className="relative overflow-hidden rounded-xl bg-cream-100" data-id="element-15" data-mp="3o2mz1kkfrgcs">
              <img src={gift.image} alt={gift.title} className="aspect-square w-full object-contain" width={512} height={512} loading="lazy" decoding="async" data-id="element-16" data-mp="3t06hyxs2whb2" />
              <span className="absolute left-2 top-2 rounded-md bg-white/90 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.1em] text-gold-500" data-id="element-17" data-mp="3ie6hxhdhm1vo">
                {gift.label}
              </span>
            </div>
            <p className="mt-3 px-0.5 font-display text-[15px] font-semibold leading-[1.3] text-ink-900" data-id="element-18" data-mp="3r5ovdkj1u3l2">
              {gift.title}
            </p>
            <p className="mt-1 px-0.5 pb-1 text-[13px] leading-[1.45] text-ink-500" data-id="element-19" data-mp="3n7is4mhf664w">
              {gift.subtitle}
            </p>
          </li>)}
      </ul>
    </section>;
}